// extracted by mini-css-extract-plugin
module.exports = {"container":"survey_container__B4dHV","answers":"survey_answers__s3ZtH","active":"survey_active__TyJrI","buttons":"survey_buttons__8E__8","button":"survey_button__fnxwq"};